<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="startDate" inputId="startDate" appendTo="body">
            </p-calendar>
            <label for="startDate">Start Date</label>
            @for (validation of validationMessages.startDate; track validation) {
              <span>
                @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="endDate" inputId="endDate" appendTo="body">
            </p-calendar>
            <label for="endDate">End Date</label>
            @for (validation of validationMessages.endDate; track validation) {
              <span>
                @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputMask formControlName="ptoHours" id="ptoHours" mask="9?9.9?9" ></p-inputMask>
            <label for="name">pto Hours</label>
            @for (validation of validationMessages.ptoHours; track validation) {
              <span>
                @if (form1.get('ptoHours').hasError(validation.type) && (form1.get('ptoHours').dirty || form1.get('ptoHours').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="ptoReasons" formControlName="ptoReason" optionLabel="name"
            optionValue="value" placeholder="Reason"></p-dropdown>
            <label for="ptoReason">Reason</label>
            @for (validation of validationMessages.ptoReason; track validation) {
              <span>
                @if (form1.get('ptoReason').hasError(validation.type) && (form1.get('ptoReason').dirty || form1.get('ptoReason').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="employeeNotes" id="employeeNotes" [rows]="2" pInputTextarea></textarea>
            <label for="description">Employee Notes</label>
            @for (validation of validationMessages.employeeNotes; track validation) {
              <span>
                @if (form1.get('employeeNotes').hasError(validation.type) && (form1.get('employeeNotes').dirty || form1.get('employeeNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (employeePtoId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!employeePtoId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (employeePtoId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>